import type { TranslationDictionary } from '../types';

export const bn: TranslationDictionary = {
  common: {
    appName: 'ApnaBlock',
    save: 'সংরক্ষণ করুন',
    cancel: 'বাতিল করুন',
    delete: 'মুছে ফেলুন',
    edit: 'সম্পাদনা করুন',
    create: 'তৈরি করুন',
    back: 'ফিরে যান',
    search: 'অনুসন্ধান করুন...',
    filter: 'ফিল্টার',
    refresh: 'রিফ্রেশ করুন',
    submit: 'জমা দিন',
    loading: 'লোড হচ্ছে...',
    close: 'বন্ধ করুন',
    yes: 'হ্যাঁ',
    no: 'না',
    active: 'সক্রিয়',
    inactive: 'নিষ্ক্রিয়',
    open: 'উন্মুক্ত',
    pending: 'বিচারাধীন',
    approved: 'অনুমোদিত',
    rejected: 'প্রত্যাখ্যাত',
    completed: 'সম্পূর্ণ',
    inProgress: 'প্রক্রিয়াধীন',
    resolved: 'সমাধান হয়েছে',
    viewDetails: 'বিস্তারিত দেখুন',
    download: 'ডাউনলোড করুন',
    print: 'প্রিন্ট করুন',
    export: 'রপ্তানি করুন',
    actions: 'পদক্ষেপ',
    status: 'অবস্থা',
    date: 'তারিখ',
    total: 'মোট',
    all: 'সকল',
    reset: 'রিসেট করুন',
    more: 'আরও',
    select: 'নির্বাচন করুন',
    language: 'ভাষা',
    selectLanguage: 'ভাষা নির্বাচন করুন',
    saveChanges: 'পরিবর্তন সংরক্ষণ করুন',
    savedSuccessfully: 'সফলভাবে সংরক্ষিত হয়েছে',
    confirm: 'নিশ্চিত করুন',
    home: 'হোম',
    favorites: 'পছন্দ',
    pinned: 'পিন করা',
    tenant: 'সোসাইটি / সম্প্রদায়',
    openMenu: 'মেনু খুলুন',
    expandMenu: 'মেনু প্রসারিত করুন',
    minimizeMenu: 'মেনু সংকুচিত করুন',
    lightMode: 'লাইট মোড',
    darkMode: 'ডার্ক মোড',
    accountMenu: 'অ্যাকাউন্ট মেনু',
    commandPalette: 'কমান্ড প্যালেট',
    searchPages: 'পৃষ্ঠা অনুসন্ধান করুন...',
    favorite: 'পছন্দ',
    pin: 'পিন করুন',
    calendar: 'ক্যালেন্ডার',
    inbox: 'ইনবক্স',
    ledger: 'খতিয়ান',
    viewAll: 'সব দেখুন',
    platformNoSociety: 'প্ল্যাটফর্ম (কোনো সোসাইটি নেই)',
    noSociety: 'কোনো সোসাইটি নেই',
    trial: 'ট্রায়াল',
    expired: 'মেয়াদোত্তীর্ণ',
    suspended: 'স্থগিত',
    emptyTitle: 'এখানে এখনও কিছু নেই',
    emptyDescription: 'বিবরণ এবং আপডেট উপলব্ধ হলে এখানে প্রদর্শিত হবে।',
    tryAgain: 'আবার চেষ্টা করুন',
    somethingWentWrong: 'কিছু ভুল হয়েছে',
    goBack: 'ফিরে যান',
    goToHome: 'হোমে যান',
    referenceId: 'রেফারেন্স আইডি',
    or: 'অথবা',
  },
  auth: {
    login: 'সাইন ইন করুন',
    logout: 'লগ আউট',
    profile: 'প্রোফাইল',
    email: 'ইমেল ঠিকানা',
    password: 'পাসওয়ার্ড',
    forgotPassword: 'পাসওয়ার্ড ভুলে গেছেন?',
    sendOtp: 'ওটিপি পাঠান',
    verifyOtp: 'ওটিপি যাচাই করুন',
    mobile: 'মোবাইল নম্বর',
    rememberMe: 'আমাকে মনে রাখুন',
    biometricLogin: 'বায়োমেট্রিক লগইন',
    changePassword: 'পাসওয়ার্ড পরিবর্তন করুন',
    signOut: 'সাইন আউট',
    welcome: 'স্বাগতম',
    signIn: 'সাইন ইন করুন',
    signInSubtitle: 'আপনার সোসাইটি ওয়ার্কস্পেসে নিরাপদে প্রবেশ করুন।',
    signingInTo: '{{name}} এ সাইন ইন করছেন',
    method: 'পদ্ধতি',
    emailTab: 'ইমেল',
    mobileTab: 'মোবাইল',
    otpTab: 'ওটিপি',
    emailLabel: 'ইমেল ঠিকানা',
    mobileLabel: 'মোবাইল নম্বর',
    passwordLabel: 'পাসওয়ার্ড',
    enableBiometricAfterLogin: 'সাইন ইন করার পর বায়োমেট্রিক লগইন সক্ষম করুন',
    signInWithBiometrics: 'বায়োমেট্রিক্স দিয়ে সাইন ইন করুন',
    verifyAndSignIn: 'যাচাই করে সাইন ইন করুন',
    changeIdentifier: 'শনাক্তকারী পরিবর্তন করুন',
    enterOtpSentTo: 'আপনার {{channel}} এ পাঠানো ওটিপি লিখুন।',
    otpCodeLabel: 'ওটিপি কোড',
    channelLabel: 'চ্যানেল',
    emailChannel: 'ইমেল',
    smsChannel: 'এসএমএস',
    forgotPasswordTitle: 'পাসওয়ার্ড ভুলে গেছেন',
    forgotPasswordSubtitle: 'আপনার ইমেল বা মোবাইল দিন। পাসওয়ার্ড রিসেট করতে ওটিপি পাঠাব।',
    emailOrMobile: 'ইমেল বা মোবাইল নম্বর',
    backToSignIn: 'সাইন ইন-এ ফিরে যান',
    resetPasswordTitle: 'পাসওয়ার্ড রিসেট করুন',
    resetPasswordSubtitle: 'আপনার ইমেল বা মোবাইলে পাঠানো ওটিপি দিন, তারপর নতুন পাসওয়ার্ড বেছে নিন।',
    newPasswordLabel: 'নতুন পাসওয়ার্ড',
    confirmPasswordLabel: 'পাসওয়ার্ড নিশ্চিত করুন',
    updatePassword: 'পাসওয়ার্ড আপডেট করুন',
    changePasswordTitle: 'পাসওয়ার্ড পরিবর্তন করুন',
    changePasswordSubtitle: 'আপনার অ্যাকাউন্ট পাসওয়ার্ড আপডেট করুন। আপনি সাইন ইন থাকবেন।',
    currentPasswordLabel: 'বর্তমান পাসওয়ার্ড',
    confirmNewPasswordLabel: 'নতুন পাসওয়ার্ড নিশ্চিত করুন',
    savePassword: 'পাসওয়ার্ড সংরক্ষণ করুন',
    passwordRequirementNotice: 'কমপক্ষে ৮ অক্ষরের হতে হবে এবং বড় হাতের অক্ষর, ছোট হাতের অক্ষর, সংখ্যা এবং বিশেষ অক্ষর থাকতে হবে।',
    bannerTagline: 'এন্টারপ্রাইজ সোসাইটি পরিচালনা — ব্যাংকিং, আদায়, মিটিং এবং বাসিন্দা এক জায়গায়।',
    bannerSubtext: 'কলোনি এবং হাউজিং সোসাইটির জন্য নিরাপদ মাল্টি-টেন্যান্ট প্ল্যাটফর্ম।',
    biometricMobileOnly: 'বায়োমেট্রিক লগইন শুধুমাত্র মোবাইল অ্যাপে উপলব্ধ।',
    biometricDesktopInfo: 'বায়োমেট্রিক লগইন ApnaBlock মোবাইল অ্যাপে উপলব্ধ।',
    signedInBiometrics: 'বায়োমেট্রিক্সের মাধ্যমে সফলভাবে সাইন ইন করা হয়েছে',
    biometricSessionExpired: 'সেশন শেষ বা প্রত্যাহার করা হয়েছে। অনুগ্রহ করে আপনার পাসওয়ার্ড দিয়ে সাইন ইন করুন।',
    biometricAuthFailed: 'বায়োমেট্রিক প্রমাণীকরণ ব্যর্থ হয়েছে। অনুগ্রহ করে পাসওয়ার্ড ব্যবহার করুন।',
    biometricEnrollSuccess: 'বায়োমেট্রিক লগইন সক্রিয় করা হয়েছে',
    biometricEnrollCancelled: 'বায়োমেট্রিক তালিকাভুক্তি বাতিল হয়েছে। সাধারণ লগইন সফল হয়েছে।',
    welcomeMarketing: 'মার্কেটিং পার্টনার পোর্টালে স্বাগতম',
    welcomePlatform: 'প্ল্যাটফর্ম প্রশাসনে স্বাগতম',
    welcomeBackToast: 'পুনরায় স্বাগতম',
    otpSentSuccess: 'ওটিপি সফলভাবে পাঠানো হয়েছে',
    otpVerifyFailed: 'ওটিপি যাচাইকরণ ব্যর্থ হয়েছে',
    loginFailed: 'লগইন ব্যর্থ হয়েছে',
    biometricAuthReason: 'ApnaBlock-এ সাইন ইন করতে আপনার পরিচয় যাচাই করুন',
    biometricAvailableFor: '{{identifier}}-এর জন্য বায়োমেট্রিক লগইন উপলব্ধ',
    biometricEnrollPrompt: '{{name}}-এর জন্য বায়োমেট্রিক লগইন সক্রিয় করবেন?',
  },
  nav: {
    dashboard: 'ড্যাশবোর্ড',
    society: 'সোসাইটি',
    societySettings: 'আমার সোসাইটি',
    societyBlocks: 'ব্লক / টাওয়ার',
    societyHouses: 'বাড়ি / ফ্ল্যাট',
    societyResidents: 'বাসিন্দা',
    societyStaff: 'কর্মী',
    imports: 'ডেটা আমদানি',
    finance: 'অর্থ ও হিসাব',
    financePayments: 'আমার পেমেন্ট',
    financeCollections: 'আদায়',
    financeSocietyFund: 'সোসাইটি ফান্ড',
    financeSpecialCollections: 'বিশেষ আদায়',
    financeCorpusFund: 'কর্পাস ফান্ড',
    financeExpenses: 'খরচ',
    financeExpenseGroups: 'ব্যয় গ্রুপ',
    financeWaterTanker: 'জলের ট্যাঙ্কার',
    financeReimbursements: 'প্রতিপূরণ দাবি',
    financeBanking: 'ব্যাংক অ্যাকাউন্ট',
    financeStatements: 'স্টেটমেন্ট ও রসিদ',
    financeReports: 'আর্থিক রিপোর্ট',
    financeReconciliation: 'পেমেন্ট সমন্বয়',
    security: 'নিরাপত্তা ও গেট',
    gatePasses: 'গেট পাস',
    securityDashboard: 'নিরাপত্তা ড্যাশবোর্ড',
    securityGates: 'গেট ব্যবস্থাপনা',
    securityShifts: 'গার্ড শিফট রিপোর্ট',
    securityPolicies: 'নিরাপত্তা নীতি',
    securityDeskPortal: 'নিরাপত্তা গেট ডেস্ক',
    visitors: 'ভিজিটর ডেস্ক',
    securityCameras: 'সিসিটিভি ক্যামেরা',
    community: 'সম্প্রদায় ও যোগাযোগ',
    notices: 'বিজ্ঞপ্তি',
    communityForum: 'কমিউনিটি ফোরাম',
    events: 'অনুষ্ঠান',
    eventsList: 'অনুষ্ঠান',
    eventsCalendar: 'অনুষ্ঠান ক্যালেন্ডার',
    invitations: 'আমন্ত্রণ ও প্রতিক্রিয়া',
    whatsapp: 'হোয়াটসঅ্যাপ লগ',
    notifications: 'বিজ্ঞপ্তিগুলি',
    operations: 'পরিচালন ও সহায়তা',
    complaints: 'অভিযোগ',
    serviceRequests: 'পরিষেবা অনুরোধ',
    serviceDirectory: 'পরিষেবা ডিরেক্টরি',
    amenities: 'সুযোগ-সুবিধা',
    meetings: 'মিটিং',
    documents: 'নথিপত্র ভল্ট',
    governance: 'শাসন ও নির্বাচন',
    polls: 'বাসিন্দা পোল',
    elections: 'নির্বাচন',
    governancePetitions: 'পিটিশন জমা দিন',
    governanceResignation: 'পদত্যাগ জমা দিন',
    administration: 'প্রশাসন',
    adminLicense: 'লাইসেন্স',
    adminInvoices: 'সাবস্ক্রিপশন ইনভয়েস',
    adminRoles: 'ভূমিকা ও অনুমতি',
    adminLetterhead: 'লেটারহেড ও ব্র্যান্ডিং',
    adminIntegrations: 'এসএমএস ও হোয়াটসঅ্যাপ',
    adminAiConfig: 'এআই কনফিগারেশন',
    adminNavigation: 'মেনু কাস্টমাইজেশন',
    adminAudit: 'অডিট লগ',
    documentationGroup: 'সহায়তা ও নথিপত্র',
    societySupportDesk: 'সহায়তা ও সাপোর্ট',
    docsKnowledgeBase: 'জ্ঞান কেন্দ্র',
    docsRoleMatrix: 'ভূমিকা ও অনুমতি ম্যাট্রিক্স',
    docsQaHub: 'কিউএ টেস্ট হাব',
    docsTestExplorer: 'টেস্ট কেস এক্সপ্লোরার',
    licenseLocked: 'লাইসেন্স',
    platformSocietiesGroup: 'সোসাইটি ও ভাড়াটে',
    platformSocieties: 'সমস্ত সোসাইটি',
    platformSocietiesNew: 'সোসাইটি নিবন্ধন করুন',
    platformSocietyTypes: 'সোসাইটি ধরন ও শ্রেণিবিভাগ',
    platformTrials: 'বিনামূল্যে ট্রায়াল',
    platformSubscriptions: 'সাবস্ক্রিপশন',
    platformLicenses: 'সফটওয়্যার লাইসেন্স',
    platformPlans: 'সাবস্ক্রিপশন প্ল্যান',
    platformInvoices: 'বিলিং ও চালান',
    platformPricingOverrides: 'মূল্য নির্ধারণ পরিবর্তন',
    platformCoupons: 'কুপন ও ছাড়',
    platformPromotionGroup: 'বৃদ্ধি ও প্রচার',
    platformPromotionDashboard: 'গ্রোথ ড্যাশবোর্ড',
    platformPromotionProspects: 'সম্ভাব্য গ্রাহক ও লিডস',
    platformPromotionCampaigns: 'প্রচারণা',
    platformPromotionTemplates: 'মেসেজ টেমপ্লেট',
    platformPromotionSenderProfiles: 'প্রেরক প্রোফাইল',
    platformPromotionEmail: 'ইমেল মার্কেটিং',
    platformPromotionWhatsapp: 'হোয়াটসঅ্যাপ ব্রডকাস্ট',
    platformPromotionSms: 'এসএমএস মার্কেটিং',
    platformPromotionOther: 'অন্যান্য চ্যানেল',
    platformReferrals: 'অ্যাফিলিয়েট ও রেফারেল',
    platformMarketing: 'মার্কেটিং কর্মী',
    platformPromotionAnalytics: 'প্রচার অ্যানালিটিক্স',
    platformPromotionSettings: 'মার্কেটিং সেটিংস',
    platformManagementGroup: 'প্ল্যাটফর্ম ও সহায়তা',
    platformWebsite: 'ওয়েবসাইট সিএমএস ও ব্র্যান্ডিং',
    platformSupportTickets: 'সাপোর্ট টিকিট ডেস্ক',
    platformFeatureRequests: 'ফিচার অনুরোধ',
    platformFeatures: 'ফিচার ফ্ল্যাগ',
    platformUsers: 'প্ল্যাটফর্ম প্রশাসক',
    platformCoverageAudit: 'ডকুমেন্টস কভারেজ অডিট',
    platformReportsGroup: 'অ্যানালিটিক্স ও রিপোর্ট',
    platformAnalytics: 'প্ল্যাটফর্ম অ্যানালিটিক্স',
    platformSystemGroup: 'সিস্টেম ও নিরাপত্তা',
    platformSystemHealth: 'সিস্টেম স্বাস্থ্য',
    platformAuditLogs: 'অডিট লগ',
    platformNotifications: 'সতর্কতা ও বিজ্ঞপ্তি',
    platformSettings: 'গ্লোবাল সেটিংস',
    platformDataCleanup: 'ডেটা ক্লিনআপ',
    platformGoogleCalendar: 'গুগল ক্যালেন্ডার ইন্টিগ্রেশন',
    platformMaintenance: 'ডাটাবেস রক্ষণাবেক্ষণ',
    directory: 'বাসিন্দাদের ডিরেক্টরি',
    members: 'সদস্যবৃন্দ',
    houses: 'ইউনিট ও ফ্ল্যাট',
    settings: 'সেটিংস',
    myUnit: 'আমার ইউনিট',
    waterTankers: 'জলের ট্যাঙ্কার',
    patrol: 'গার্ড টহল',
    cameras: 'লাইভ সিসিটিভি',
    marketplace: 'মার্কেটপ্লেস',
    profile: 'আমার প্রোফাইল',
    superAdmin: 'প্ল্যাটফর্ম অ্যাডমিন',
    staff: 'সোসাইটি কর্মী',
    helpDesk: 'হেল্পডেস্ক',
    favorites: 'পছন্দ',
    pinned: 'পিন করা',
    navGroupHome: 'হোম',
    navGroupSociety: 'আমার সোসাইটি',
    navGroupMoney: 'টাকা ও বকেয়া',
    navGroupSecurity: 'নিরাপত্তা ও গেট',
    navGroupCommunity: 'কমিউনিটি',
    navGroupManagement: 'ব্যবস্থাপনা',
    navGroupAdmin: 'প্রশাসন',
    navGroupHelp: 'সহায়তা ও তথ্য',
    securityNotificationSettings: 'নিরাপত্তা নীতি',
    securityCcCameras: 'সিসিটিভি ক্যামেরা',
  },
  mobile: {
    greetingMorning: 'সুপ্রভাত, {{name}}',
    greetingAfternoon: 'শুভ দুপুর, {{name}}',
    greetingEvening: 'শুভ সন্ধ্যা, {{name}}',
    greetingNight: 'শুভ রাত্রি, {{name}}',
    greetingGeneric: 'স্বাগতম, {{name}}',
    priorityAttention: 'জরুরি দৃষ্টি আকর্ষণ',
    priorityAllClear: 'সব বকেয়া পরিশোধিত',
    priorityAllClearSub: 'কোনো বকেয়া মেইনটেন্যান্স নেই',
    payMaintenance: 'মেইনটেন্যান্স দিন',
    payDues: 'এখনই পরিশোধ করুন',
    viewDues: 'বকেয়া দেখুন',
    viewReceipt: 'রসিদ দেখুন',
    dueBy: 'শেষ তারিখ {{date}}',
    quickActions: 'দ্রুত অ্যাকশন',
    actionPay: 'বকেয়া পরিশোধ',
    actionVisitors: 'অতিথি',
    actionRaiseIssue: 'অভিযোগ জানান',
    actionNotices: 'নোটিশ বোর্ড',
    actionBookFacility: 'সুবিধা বুক করুন',
    actionEmergency: 'জরুরি SOS',
    actionDirectory: 'ডিরেক্টরি',
    actionPolls: 'ভোট ও পোল',
    actionMeetings: 'মিটিং',
    societyUpdates: 'সোসাইটি আপডেট',
    gateAndVisitors: 'গেট ও অতিথি',
    upcomingEvents: 'আসন্ন অনুষ্ঠান',
    maintenanceAndReceipts: 'মেইনটেন্যান্স ও রসিদ',
    pendingApprovals: 'অনুমোদন বাকি',
    collectionsOverview: 'আদায় বিবরণ',
    pendingReview: 'পর্যালোচনা বাকি',
    noPendingReviews: 'সব পর্যালোচনা সম্পন্ন',
    totalCollected: 'মোট আদায়',
    totalOutstanding: 'মোট বকেয়া',
    activeGatePasses: 'সক্রিয় গেট পাস',
    noVisitorsToday: 'আজ কোনো অতিথি আসেননি',
    noActivePasses: 'কোনো সক্রিয় পাস নেই',
    preApproveGuest: 'অতিথি প্রাক-অনুমোদন',
    recentReceipts: 'সাম্প্রতিক রসিদ',
    noRecentReceipts: 'কোনো সাম্প্রতিক লেনদেন নেই',
    managementDesk: 'কমিটি ডেস্ক',
    switchRole: 'ভিউ পরিবর্তন',
    residentView: 'নিবাসী ভিউ',
    committeeView: 'কমিটি ভিউ',
    emergencyModalTitle: 'জরুরি SOS সতর্কবার্তা',
    emergencyModalSubtitle: 'নিরাপত্তা গার্ড এবং সোসাইটি কমিটির কাছে অবিলম্বে জরুরি বার্তা পাঠান',
    tapToCall: 'গার্ডকে কল করুন',
    tapToWhatsApp: 'অফিস হোয়াটসঅ্যাপ',
    pullToRefresh: 'রিফ্রেশ করতে নিচে টানুন',
    refreshing: 'রিফ্রেশ হচ্ছে…',
    noMeetingsScheduled: 'কোনো মিটিং নির্ধারিত নেই',
    noNoticesPublished: 'কোনো ঘোষণা প্রকাশিত হয়নি',
    noUpcomingEvents: 'কোনো আসন্ন অনুষ্ঠান নেই',
    viewAllNotices: 'সব নোটিশ দেখুন',
    viewAllEvents: 'সব অনুষ্ঠান দেখুন',
    viewAllComplaints: 'সব অভিযোগ দেখুন',
    sectionDiscover: 'আবিষ্কার করুন',
    sectionEngage: 'যুক্ত হন',
    sectionPay: 'পেমেন্ট',
    cardResidents: 'বাসিন্দা',
    cardResidentsDesc: 'আপনার সোসাইটির লোকেদের সন্ধান করুন',
    cardLocalHelp: 'স্থানীয় সাহায্য',
    cardLocalHelpDesc: 'দৈনন্দিন গৃহস্থালি সাহায্য পান',
    cardEmergencyContacts: 'জরুরি যোগাযোগ',
    cardEmergencyContactsDesc: 'পুলিশ, অ্যাম্বুলেন্স এবং জরুরি নম্বর',
    cardHelpDesk: 'সহায়তা ও অভিযোগ',
    cardHelpDeskDesc: 'সমস্যা জানান বা সাহায্য চান',
    cardFacilities: 'সুযোগ-সুবিধা',
    cardFacilitiesDesc: 'সোসাইটির সুবিধা বুক করুন',
    cardNotices: 'সোসাইটি নোটিশ',
    cardNoticesDesc: 'সোসাইটির গুরুত্বপূর্ণ আপডেট',
    cardCommunity: 'কমিউনিটি',
    cardCommunityDesc: 'পোল, মিটিং এবং ইভেন্ট',
    cardDocuments: 'নথিপত্র',
    cardDocumentsDesc: 'সোসাইটি ও ব্যক্তিগত নথি',
    cardPaymentsDues: 'পেমেন্ট ও বকেয়া',
    cardPaymentsDuesDesc: 'বকেয়া দেখুন এবং পরিশোধ করুন',
    cardUtilities: 'ইউটিলিটি',
    cardUtilitiesDesc: 'বিদ্যুৎ, জল ও অন্যান্য পরিষেবা',
    actionRequired: 'মনোযোগ প্রয়োজন',
    pendingActionSubtitle: '{{count}}টি বিষয়ে কমিটির পর্যালোচনা প্রয়োজন',
    collectionsStatus: 'আদায় ও বকেয়া',
    uncollectedSocietyDues: '{{count}}টি মুলতুবি পেমেন্ট',
    collectedThisMonth: 'এই মাসে সংগৃহীত মোট অর্থ',
    viewLedger: 'লেজার দেখুন',
    committeeActions: 'কমিটি কার্যক্রম',
    postNotice: 'নোটিশ প্রকাশ করুন',
    postNoticeDesc: 'সোসাইটিতে আনুষ্ঠানিক নোটিশ পাঠান',
    addExpense: 'খরচ যোগ করুন',
    addExpenseDesc: 'সোসাইটির খরচ নথিভুক্ত করুন',
    scheduleMeeting: 'মিটিং নির্ধারণ করুন',
    scheduleMeetingDesc: 'কমিটির মিটিং আয়োজন করুন',
    residentDirectory: 'বাসিন্দা ডিরেক্টরি',
    residentDirectoryDesc: 'বাসিন্দাদের খুঁজুন এবং যোগাযোগ করুন',
    complaintsOverview: 'অভিযোগ ও হেল্পডেস্ক',
    upcomingMeetingsCount: '{{count}}টি আসন্ন মিটিং',
    viewMeetingAgenda: 'মিটিংয়ের বিবরণ ও এজেন্ডা দেখুন',
    resignOfficeTitle: 'পদত্যাগ জমা দিন',
    resignOfficeNotice: 'সোসাইটি সদস্যদের কাছে আনুষ্ঠানিক পদত্যাগ জমা দিন',
    activeSocietyElections: 'সক্রিয় সোসাইটি নির্বাচন',
    votingLiveStatus: 'সদস্যদের জন্য ভোটদান চলছে',
    castYourVotePrompt: 'মনোনীত কমিটি প্রার্থীদের আপনার ভোট দিন',
    recentNotices: 'সাম্প্রতিক বিজ্ঞপ্তি',
    myComplaints: 'আমার অভিযোগ',
    noActiveComplaints: 'কোনো সক্রিয় অভিযোগ বা টিকিট নেই',
  },
  profile: {
    profileTitle: 'প্রোফাইল ও পছন্দসমূহ',
    profileSubtitle: 'আপনার ব্যক্তিগত বিবরণ, নিরাপত্তা সেটিংস এবং অ্যাপের ভাষা পরিচালনা করুন।',
    basicDetails: 'মৌলিক বিবরণ',
    firstName: 'নামের প্রথম অংশ',
    lastName: 'নামের শেষ অংশ',
    email: 'ইমেল ঠিকানা',
    mobile: 'মোবাইল নম্বর',
    saveDetails: 'বিবরণ সংরক্ষণ করুন',
    userId: 'ব্যবহারকারী আইডি',
    roles: 'নির্ধারিত ভূমিকা',
    tenant: 'সোসাইটি / সম্প্রদায়',
    securityBiometrics: 'নিরাপত্তা ও বায়োমেট্রিক্স',
    securityBiometricsDesc: 'ফিঙ্গারপ্রিন্ট বা ফেস আইডি ব্যবহার করে দ্রুত ও নিরাপদে অ্যাপ খুলুন।',
    biometricLoginEnabled: 'বায়োমেট্রিক লগইন সক্রিয় আছে',
    enableBiometricLogin: 'বায়োমেট্রিক লগইন সক্ষম করুন',
    notificationPreferences: 'বিজ্ঞপ্তি পছন্দসমূহ',
    notificationPreferencesDesc: 'সোসাইটির নোটিস এবং সতর্কবার্তা কীভাবে পাবেন তা নিয়ন্ত্রণ করুন।',
    languagePreferences: 'অ্যাপের ভাষা',
    languagePreferencesDesc: 'আপনার পছন্দের ভাষা নির্বাচন করুন। অ্যাপটি সর্বদা এই ভাষাতেই খুলবে।',
    currentLanguage: 'বর্তমান ভাষা',
    selectDefaultLanguage: 'ডিফল্ট ভাষা নির্বাচন করুন',
    defaultLanguageNotice: 'আপনার নির্বাচিত ভাষা সংরক্ষিত হয়েছে এবং প্রতিবার অ্যাপ খোলার সময় প্রযোজ্য হবে।',
    saveLanguage: 'ডিফল্ট ভাষা হিসেবে সেট করুন',
    languageUpdated: 'ভাষার পছন্দ সফলভাবে সংরক্ষিত হয়েছে',
  },
  dashboard: {
    welcomeBack: 'স্বাগতম',
    welcomeBackUser: 'স্বাগতম, {{name}}',
    societyWorkspace: 'আপনার সোসাইটি ওয়ার্কস্পেস',
    platformSubtitle: 'ব্যোরা প্ল্যাটফর্ম · সোসাইটি ও সফটওয়্যার লাইসেন্স',
    registerSociety: 'সোসাইটি নিবন্ধন করুন',
    registerSocietyHint: 'টেন্যান্ট ও প্রেসিডেন্ট লগইন তৈরি করুন',
    allSocieties: 'সমস্ত সোসাইটি',
    allSocietiesHint: 'তালিকা ও স্ট্যাটাস',
    softwareLicenses: 'সফটওয়্যার লাইসেন্স',
    softwareLicensesHint: 'সোসাইটি নির্বাচন করুন, লাইসেন্স ইস্যু বা পর্যালোচনা করুন',
    bankBalance: 'ব্যাংক ব্যালেন্স',
    outstandingDues: 'বকেয়া পাওনা',
    residents: 'বাসিন্দা',
    openRequests: 'খোলা অনুরোধ',
    upcomingMeetings: 'আসন্ন মিটিং',
    platform: 'প্ল্যাটফর্ম',
    societies: 'সোসাইটিগুলি',
    licenses: 'লাইসেন্সগুলি',
    noBankAccounts: 'এখনও কোনো ব্যাংক অ্যাকাউন্ট নেই',
    allDuesCleared: 'সমস্ত বকেয়া পরিশোধিত',
    noOpenComplaints: 'কোনো খোলা অভিযোগ নেই',
    noMeetingsScheduled: 'কোনো মিটিং নির্ধারিত নেই',
    overdueAndOpen: '{{overdue}} মেয়াদোত্তীর্ণ · {{open}} খোলা বিল',
    openBillsCount: '{{count}} খোলা বিল',
    openBillsCountSingle: '১টি বকেয়া বিল',
    accountsCountThisMonth: '{{count}} অ্যাকাউন্ট · এই মাসে {{amount}} এসেছে',
    accountsCountThisMonthSingle: '১টি অ্যাকাউন্ট · এই মাসে {{amount}} জমা',
    residentsAndHouses: '{{residents}} বাসিন্দা · {{houses}} বাড়ি',
    residentsOnRecord: '{{count}} নথিতে রয়েছেন',
    housesCount: '{{count}} বাড়ি',
    pendingReviewOverdue: '{{pending}} পর্যালোচনাধীন · {{overdue}} মেয়াদোত্তীর্ণ',
    pendingReview: '{{count}} পর্যালোচনাধীন',
    statManage: 'পরিচালনা',
    statSubscription: 'সাবস্ক্রিপশন',
    collectionsCashflow: 'আদায় ও নগদ প্রবাহ',
    collected: 'সংগৃহীত',
    outstanding: 'বকেয়া',
    thisMonthCashflow: 'এই মাসে · আগমন {{credit}} / ব্যয় {{debit}}',
    cashflow: 'নগদ প্রবাহ',
    quickActions: 'দ্রুত পদক্ষেপ',
    scheduleMeeting: 'মিটিং নির্ধারণ করুন',
    scheduleMeetingHint: 'মালিক ও ক্যালেন্ডারে অবহিত করুন',
    postNotice: 'বিজ্ঞপ্তি প্রকাশ করুন',
    postNoticeHint: 'সোসাইটিতে ঘোষণা করুন',
    raiseComplaint: 'অভিযোগ দায়ের করুন',
    raiseComplaintHint: 'পরিষেবা অনুরোধ নথিভুক্ত করুন',
    filePetition: 'পিটিশন জমা দিন',
    filePetitionHint: 'পদত্যাগ দাবি বা পদক্ষেপ',
    viewProfile: 'প্রোফাইল দেখুন',
    viewProfileHint: 'অ্যাকাউন্ট ও অনুমতি',
    publicPetitions: 'পাবলিক পিটিশন',
    openPetitions: 'খোলা পিটিশন · সমস্ত সদস্যদের জন্য দৃশ্যমান',
    openBoard: 'বোর্ড খুলুন',
    noMeetingsDescription: 'আসন্ন কমিটি মিটিং এখানে প্রদর্শিত হবে।',
    announcements: 'ঘোষণাসমূহ',
    noAnnouncements: 'কোনো ঘোষণা নেই',
    noAnnouncementsDesc: 'প্রকাশিত বিজ্ঞপ্তি এখানে দেখা যাবে।',
    recentActivity: 'সাম্প্রতিক কার্যকলাপ',
    noActivity: 'এখনও কোনো কার্যকলাপ নেই',
    noActivityDesc: 'বিজ্ঞপ্তি এবং আপডেট এখানে প্রদর্শিত হবে।',
    recentTransactions: 'সাম্প্রতিক লেনদেন',
    visitorActivity: 'ভিজিটর কার্যকলাপ',
    visitorsComingSoon: 'ভিজিটর মডিউল শীঘ্রই আসছে',
    visitorsComingSoonDesc: 'ভিজিটর মডিউল সক্রিয় হলে গেট লগ এখানে প্রদর্শিত হবে।',
    openVisitors: 'ভিজিটর খুলুন',
    recentNotices: 'সাম্প্রতিক বিজ্ঞপ্তি',
    pendingComplaints: 'অমীমাংসিত অভিযোগ',
    upcomingEvents: 'আসন্ন অনুষ্ঠানসমূহ',
    maintenanceDue: 'রক্ষণাবেক্ষণ বকেয়া',
    visitorsToday: 'আজকের দর্শনার্থী',
    viewAll: 'সব দেখুন',
    societyOverview: 'সোসাইটি ওভারভিউ',
    activeNotices: 'সক্রিয় বিজ্ঞপ্তি',
  },
  complaints: {
    title: 'হেল্পডেস্ক ও অভিযোগ',
    createComplaint: 'অভিযোগ দায়ের করুন',
    category: 'বিভাগ',
    priority: 'অগ্রাধিকার',
    status: 'অবস্থা',
    description: 'বর্ণনা',
    raisedBy: 'দায়েরকারী',
    assignedTo: 'দায়িত্বপ্রাপ্ত',
    resolve: 'সমাধান চিহ্নিত করুন',
    myComplaints: 'আমার অভিযোগ',
    allComplaints: 'সোসাইটির সকল অভিযোগ',
  },
  visitors: {
    title: 'দর্শনার্থী ব্যবস্থাপনা',
    logVisitor: 'দর্শনার্থী পূর্ব-অনুমোদন',
    visitorName: 'দর্শনার্থীর নাম',
    phone: 'ফোন নম্বর',
    hostUnit: 'ফ্ল্যাট / ইউনিট',
    purpose: 'আসার কারণ',
    vehicleNumber: 'গাড়ির নম্বর',
    checkIn: 'চেক ইন',
    checkOut: 'চেক আউট',
    expectedVisitors: 'প্রত্যাশিত অতিথি',
    activeVisitors: 'বর্তমানে ভিতরে আছেন',
  },
  finance: {
    title: 'অর্থ ও পেমেন্ট',
    dues: 'বকেয়া পাওনা',
    payNow: 'এখনই পরিশোধ করুন',
    transactions: 'লেনদেনের ইতিহাস',
    invoices: 'রক্ষণাবেক্ষণ বিল',
    receipts: 'পেমেন্ট রসিদ',
    paymentHistory: 'পেমেন্টের ইতিহাস',
    maintenanceFee: 'মাসিক রক্ষণাবেক্ষণ ফি',
    outstandingBalance: 'মোট বকেয়া',
    paid: 'পরিশোধিত',
    unpaid: 'অপরিশোধিত',
  },
  notices: {
    title: 'সোসাইটি নোটিস',
    createNotice: 'বিজ্ঞপ্তি প্রকাশ করুন',
    important: 'জরুরি বিজ্ঞপ্তি',
    publishedOn: 'প্রকাশের তারিখ',
    readMore: 'সম্পূর্ণ পড়ুন',
    attachments: 'সংযুক্ত নথি',
    societyAnnouncements: 'সম্প্রদায়ের ঘোষণা',
  },
  amenities: {
    title: 'সোসাইটি সুযোগ-সুবিধা',
    bookAmenity: 'সুবিধা বুক করুন',
    myBookings: 'আমার বুকিং',
    availableSlots: 'উপলব্ধ স্লট',
    rules: 'নিয়মাবলী',
  },
  elections: {
    title: 'নির্বাচন ও ভোটদান',
    activeElections: 'সক্রিয় নির্বাচন',
    castVote: 'আপনার ভোট দিন',
    candidates: 'প্রার্থী তালিকা',
    results: 'ফলাফল',
  },
  emergency: {
    emergencyAlert: 'জরুরি সতর্কতা (EMERGENCY)',
    triggerAlert: 'এসওএস অ্যালার্ট পাঠান',
    fire: 'অগ্নিকাণ্ড জরুরি অবস্থা',
    medical: 'চিকিৎসা জরুরি অবস্থা',
    security: 'নিরাপত্তা ঝুঁকি',
    panic: 'প্যানিক বাটন',
    sos: 'এসওএস সম্প্রচার',
    activeAlert: 'জরুরি সতর্কতা সক্রিয় রয়েছে',
  },
  validation: {
    required: 'এই তথ্যটি বাধ্যতামূলক।',
    invalidEmail: 'অনুগ্রহ করে একটি বৈধ ইমেল ঠিকানা লিখুন।',
    invalidMobile: 'অনুগ্রহ করে একটি বৈধ ১০-সংখ্যার মোবাইল নম্বর লিখুন।',
    passwordTooShort: 'পাসওয়ার্ড কমপক্ষে ৮ অক্ষরের হতে হবে।',
    positiveNumber: 'অনুগ্রহ করে একটি ধনাত্মক মান লিখুন।',
  },
  superAdmin: {
    title: 'প্ল্যাটফর্ম প্রশাসন',
    dashboard: 'ড্যাশবোর্ড',
    platformOverview: 'প্ল্যাটফর্ম ওভারভিউ',
    platformOverviewSubtitle: 'রিয়েল-টাইম বহু-টেন্যান্ট সোসাইটি মেট্রিক্স, সাবস্ক্রিপশন স্বাস্থ্য ও প্ল্যাটফর্ম কার্যকলাপ',
    totalSocieties: 'মোট সোসাইটি',
    societiesActiveAndTrial: '{{active}} সক্রিয় · {{trial}} ট্রায়ালে',
    monthlyRecurring: 'মাসিক পুনরাবৃত্ত রাজস্ব (MRR)',
    annualRecurring: 'বার্ষিক ARR: {{arr}}',
    activeTrials: 'সক্রিয় ট্রায়াল',
    expiringInDays: '৩০ দিনে {{count}} মেয়াদ শেষ হচ্ছে',
    totalPlatformUsers: 'মোট প্ল্যাটফর্ম ব্যবহারকারী',
    acrossAllManagedSocieties: 'সমস্ত পরিচালিত সোসাইটি জুড়ে',
    upcomingExpirations: 'আসন্ন ট্রায়াল ও লাইসেন্স মেয়াদ শেষ (পরবর্তী ৩০ দিন)',
    upcomingExpirationsSubtitle: 'ট্রায়াল বৃদ্ধি, পুনর্নবীকরণ বা রূপান্তর প্রয়োজন এমন সোসাইটিগুলি',
    noUpcomingExpirations: 'পরবর্তী ৩০ দিনে কোনো লাইসেন্সের মেয়াদ শেষ হচ্ছে না।',
    societyName: 'সোসাইটির নাম',
    plan: 'প্ল্যান',
    expiresIn: 'মেয়াদ শেষ হতে বাকি',
    manage: 'পরিচালনা',
    subscriptionTierShare: 'সাবস্ক্রিপশন প্ল্যান অংশ',
    subscriptionTierShareSubtitle: 'প্ল্যান অনুযায়ী সক্রিয় সোসাইটি বিতরণ',
    noPlanDistribution: 'কোনো প্ল্যান বিতরণ ডেটা উপলব্ধ নেই',
    daysCount: '{{count}} দিন',
    expiredToday: 'আজই মেয়াদ শেষ হয়েছে',
    freeTrial: 'বিনামূল্যে ট্রায়াল',
    analytics: 'প্ল্যাটফর্ম অ্যানালিটিক্স',
    societies: 'সমস্ত সোসাইটি',
    societyTypes: 'সোসাইটির ধরন',
    trials: 'বিনামূল্যে ট্রায়াল ও অনবোর্ডিং',
    subscriptions: 'সাবস্ক্রিপশন',
    licenses: 'সফটওয়্যার লাইসেন্স',
    plans: 'সাবস্ক্রিপশন প্ল্যান',
    invoices: 'বিলিং ও চালান',
    pricingOverrides: 'মূল্য নির্ধারণ পরিবর্তন',
    coupons: 'কুপন ও ছাড়',
    promotion: 'বৃদ্ধি ও প্রচার',
    referrals: 'অ্যাফিলিয়েট ও রেফারেল',
    marketing: 'মার্কেটিং কর্মী',
    websiteCms: 'ওয়েবসাইট সিএমএস ও ব্র্যান্ডিং',
    features: 'ফিচার ফ্ল্যাগ',
    platformUsers: 'প্ল্যাটফর্ম প্রশাসক',
    systemHealth: 'সিস্টেম স্বাস্থ্য',
    auditLogs: 'অডিট লগ',
    settings: 'গ্লোবাল সেটিংস',
    dataCleanup: 'ডেটা ক্লিনআপ',
    maintenance: 'ডাটাবেস রক্ষণাবেক্ষণ',
  },
  tables: {
    noRecords: 'কোনো রেকর্ড খুঁজে পাওয়া যায়নি',
    rowsPerPage: 'প্রতি পৃষ্ঠায় সারি:',
    pageOf: 'পৃষ্ঠা {{page}} / {{totalPages}}',
    filterResults: 'ফলাফল ফিল্টার করুন...',
    showingResults: 'মোট {{count}} টি ফলাফল দেখানো হচ্ছে',
  },
  dialogs: {
    confirmAction: 'পদক্ষেপ নিশ্চিত করুন',
    confirmDelete: 'মুছে ফেলা নিশ্চিত করুন',
    areYouSure: 'আপনি কি নিশ্চিত যে আপনি এগিয়ে যেতে চান?',
    irreversibleNotice: 'এই পদক্ষেপটি পূর্বাবস্থায় ফেরানো যাবে না।',
    discardChanges: 'সংরক্ষণ না করা পরিবর্তনগুলি বর্জন করবেন?',
  },
  feedback: {
    savedSuccess: 'বিবরণ সফলভাবে সংরক্ষিত হয়েছে',
    updateSuccess: 'সফলভাবে আপডেট করা হয়েছে',
    errorOccurred: 'একটি ত্রুটি ঘটেছে। অনুগ্রহ করে আবার চেষ্টা করুন।',
    languageChanged: 'ভাষা বাংলায় পরিবর্তিত হয়েছে',
    biometricEnabledSuccess: 'বায়োমেট্রিক নিরাপত্তা সক্রিয় করা হয়েছে',
    biometricDisabledSuccess: 'বায়োমেট্রিক নিরাপত্তা নিষ্ক্রিয় করা হয়েছে',
  },
};
